"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportGeneratorFilter_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReportGeneratorFilter_Factory = /** @class */ (function () {
    function ReportGeneratorFilter_Factory() {
    }
    ReportGeneratorFilter_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    ReportGeneratorFilter_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    return ReportGeneratorFilter_Factory;
}());
exports.ReportGeneratorFilter_Factory = ReportGeneratorFilter_Factory;
